var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";

import { ScrollbarSize } from "./constants";
import { Scrollbar } from "./Scrollbar";
// export const ScrollbarSize = 12;
export var ScrollableArea = function (_Component) {
  _inherits(ScrollableArea, _Component);

  function ScrollableArea(props) {
    _classCallCheck(this, ScrollableArea);

    var _this = _possibleConstructorReturn(this, (ScrollableArea.__proto__ || Object.getPrototypeOf(ScrollableArea)).call(this, props));

    _this.getRatios = function () {
      return _this.ratios;
    };

    _this.getScrollbars = function (height, width, ratios) {
      var scrollbars = {};
      if (ratios.vertical.display < 1 && !_this.props.noVerticalScrollbar) {
        scrollbars.vertical = { width: ScrollbarSize };
      }
      if (ratios.horizontal.display < 1) {
        scrollbars.horizontal = { width: ScrollbarSize, width2: ScrollbarSize };
      }
      if (scrollbars.vertical && scrollbars.horizontal) {
        scrollbars.horizontal.length = width - ScrollbarSize;
        scrollbars.vertical.length = height - ScrollbarSize;
      } else if (scrollbars.vertical) {
        scrollbars.vertical.length = Math.min(height, height / ratios.vertical.display);
        scrollbars.horizontal = {
          length: Math.min(width - ScrollbarSize, ratios.horizontal.size || (width - ScrollbarSize) / ratios.horizontal.display
          // width / ratios.horizontal.display
          ),
          width: 0,
          width2: 0
        };
      } else if (scrollbars.horizontal) {
        scrollbars.horizontal.length = Math.min(width, width / ratios.horizontal.display);
        if (_this.props.locked) {
          scrollbars.horizontal.width = 0;
        }
        scrollbars.vertical = {
          length: Math.min(height - ScrollbarSize, ratios.vertical.size || (height - ScrollbarSize) / ratios.vertical.display
          // height / ratios.vertical.display
          ),
          width: 0
        };
      } else {
        scrollbars.horizontal = {
          length: Math.min(width, width / ratios.horizontal.display),
          width: 0,
          width2: 0
        };
        scrollbars.vertical = {
          length: Math.min(height, height / ratios.vertical.display),
          width: 0
        };
      }

      scrollbars.horizontal.innerSize = Math.max(30, width * ratios.horizontal.display);
      scrollbars.vertical.innerSize = Math.max(30, height * ratios.vertical.display);
      _this.scrollbars = scrollbars;
      return scrollbars;
    };

    _this._getContent = function () {
      return _this.getContent();
    };

    _this.getContent = function () {
      return [];
    };

    _this.onScrollEvent = function (e) {
      if (e.type === "scrollbar") {
        if (e.initiator === "bar") {
          if (e.direction === "horizontal") {
            _this.ratios.horizontal.position = e.positionRatio;
          } else {
            _this.ratios.vertical.position = e.positionRatio;
          }
          if (_this.props.onScroll) {
            _this.props.onScroll(e);
          }
        }
        return true;
      }
      return false;
    };

    _this.collect = function (e) {
      var button = e.button,
          shiftKey = e.shiftKey,
          target = e.target,
          clientX = e.clientX,
          clientY = e.clientY;

      var initiator = e.target.id.startsWith("thumb") ? "thumb" : "bar";
      var rect = target.getBoundingClientRect();
      var left = rect.left,
          top = rect.top;

      var x = clientX - left,
          y = clientY - top,
          position = Math.max(0, Math.min((_this.props.direction === "horizontal" ? x : y) - _this.innerSize / 2, _this.props.length - _this.innerSize));
      var event = {
        type: "scrollbar",
        direction: _this.props.direction,
        button: button,
        shiftKey: shiftKey,
        clientX: clientX,
        clientY: clientY,
        x: x,
        y: y,
        positionRatio: position / _this.props.length,
        position: position,
        initiator: initiator
      };
      return event;
    };

    _this._handleDrag = function (type, event) {
      var length = _this.scrollbars[event.direction].length;

      var display = _this.ratios[event.direction].display;
      var size = Math.max(display * length, 30);
      if (type === "startDrag") {
        _this.drag[event.direction] = {
          isDragging: true,
          previousPosition: event.position,
          previousPositionRatio: _this.ratios[event.direction].position
        };
        // this.positionRatio = this.props.positionRatio;
      } else if (type === "endDrag") {
        _this.drag[event.direction] = { isDragging: false };
      } else if (type === "drag" && _this.drag[event.direction].isDragging) {
        var drag = _this.drag[event.direction];
        var delta = event.position - drag.previousPosition;
        if (delta) {
          event.positionRatio = Math.min(Math.max(drag.previousPositionRatio + delta / length, 0), 1 - display);
          event.sense = Math.sign(-delta);
          // event.position = length * event.positionRatio;
          if (_this.onScrollEvent(event)) {
            // console.log(
            //   "drag",
            //   event.position,
            //   event.positionRatio,
            //   this.ratios[event.direction].position
            // );
            drag.previousPosition = event.position;
            drag.previousPositionRatio = event.positionRatio;
          }
        }
      } else if (type === "click") {
        if (event.relativePosition + size / 2 > length) {
          event.positionRatio = 1 - display;
        } else {
          event.positionRatio = Math.max(0, (event.relativePosition - size / 2) / length);
        }
        event.sense = Math.sign(_this.ratios[event.direction].position - event.positionRatio);
        _this.onScrollEvent(event);
        // console.log("click area", length, size, event);
      }
    };

    _this._handleMouseMove = function (e) {
      if ((_this.drag.vertical.isDragging || _this.drag.horizontal.isDragging) && e.buttons) {
        e.preventDefault();
        var direction = _this.drag.vertical.isDragging ? "vertical" : "horizontal";
        _this._handleDrag("drag", {
          type: "scrollbar",
          direction: direction,
          position: direction === "horizontal" ? e.clientX : e.clientY
        });
      }
    };

    _this._handleMouseUp = function (e) {
      _this.drag.vertical.isDragging = false;
      _this.drag.horizontal.isDragging = false;
    };

    _this.ratios = {
      vertical: { display: 1, position: 0 },
      horizontal: { display: 1, position: 0 }
    };
    _this.drag = { vertical: {}, horizontal: {} };
    return _this;
  }

  _createClass(ScrollableArea, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          height = _props.height,
          width = _props.width,
          gridId = _props.gridId;


      this.ratios = this.getRatios(this.props);
      if (!this.ratios) {
        return null;
      }
      var scrollbars = this.getScrollbars(height, width, this.ratios);
      var content = this._getContent(height, width);
      var style = {
        position: "relative",
        overflow: "hidden",
        height: scrollbars.vertical.length,
        width: scrollbars.horizontal.length
      };
      // console.log("ratios", this.ratios.horizontal);
      return React.createElement(
        "div",
        {
          id: "grid " + gridId
          // style={this.props.style || {}}
          , onMouseMove: this._handleMouseMove,
          onMouseUp: this._handleMouseUp
          // onKeyDown={e => this.console.log("KEYDOWN", e1)}
        },
        React.createElement(
          "div",
          {
            id: "scrollable-area",
            style: Object.assign({
              width: width
            }, this.props.style || {}, {
              display: "flex"
              // overflow: "hidden"
              // width
            })
          },
          React.createElement(
            "div",
            { id: "scrollable-area-content", style: style },
            content
          ),
          React.createElement(Scrollbar, {
            direction: "vertical",
            width: scrollbars.vertical.width,
            length: scrollbars.vertical.length,
            positionRatio: this.ratios.vertical.position,
            displayRatio: this.ratios.vertical.display,
            id: "vertical-scrollbar " + gridId,
            onScroll: this.onScrollEvent,
            _handleDrag: this._handleDrag
          })
        ),
        React.createElement(Scrollbar, {
          direction: "horizontal",
          width: scrollbars.horizontal.width,
          length: scrollbars.horizontal.length,
          positionRatio: this.ratios.horizontal.position,
          displayRatio: this.ratios.horizontal.display,
          id: "horizontal-scrollbar " + gridId,
          onScroll: this.onScrollEvent,
          _handleDrag: this._handleDrag
        })
      );
    }
  }]);

  return ScrollableArea;
}(Component);


//////////////////
// WEBPACK FOOTER
// ./node_modules/zebulon-controls/lib/ScrollableArea.js
// module id = 109
// module chunks = 0